import { Attributes } from '@leverege/ui-attributes';
function toImagineAgg(model, imagineType, context = {}) {
  const {
    attrName,
    ...rest
  } = model;
  const {
    objectType
  } = context;
  const nModel = {
    ...rest
  };
  if (nModel.type === 'aggregation.terms') {
    const attribute = Attributes.getAttribute(attrName, objectType);
    if (attribute?.valueType === 'enum' || attribute?.valueType === 'resourceEnum') {
      nModel.fieldType = attribute?.source?.fieldType || 'string';
    }
  }
  return {
    ...nModel,
    type: imagineType
  };
}

// eslint-disable-next-line
export function createImagineAggregationBuilder(imagineType) {
  return (model, context) => {
    return toImagineAgg(model, imagineType, context);
  };
}